 export class HttpAddress  {
  //  webaddress:string = "http://192.168.1.104:8888/msyy/";
   webaddress:string = "https://yh.msyymsyy.com/yh/";
   public login(){//登陆
     const login="LoginAction.do?login";
     return this.webaddress+login;
   }
   public vcode(){//发送验证码
     const code = "LoginAction.do?sendVcode";
     return this.webaddress + code;
   }
   public changepass(){//修改密码
     const pass = "LoginAction.do?changePass";
     return this.webaddress + pass;
   }
   public firstloginfirm(){//检测是否第一次登陆
     const fl = "EnterpriseAction.do?findEnterprise";
     return this.webaddress + fl;
   }
   public firstloginaddress(){//检测是否第一次登陆
     const fl = "EnterpriseAction.do?findReceptionInfor";
     return this.webaddress + fl;
   }
   public checkinfor(){//检查信息
     const check = "EnterpriseAction.do?checkInfor";
     return this.webaddress+check;
   }
   public upfirminfor(){//提交公司信息
     const upinfor = "EnterpriseAction.do?updateEnterprise";
     return this.webaddress + upinfor;
   }
   public getauthorize(){//获取授权
     const getauthorize="EnterpriseAction.do?timing";
     return this.webaddress+getauthorize;
   }
   public update(){//提交修改的信息
     const update = "EnterpriseAction.do?updateReceptionInfor";
     return this.webaddress+update;
   }
   public change(){//申请修改
     const change = "EnterpriseAction.do?change";
     return this.webaddress + change;
   }
   public sortChange(){//标识种类
     const sort = "SpecsAction.do?showSpecs";
     return this.webaddress + sort;

   }
   public express(){//物流
     const exp = "ShopcenterAction.do?showShopcenter";
     return this.webaddress + exp;
   }
   public specchang(){//选择制品规格
     const spec = "SpecsAction.do?showMoney";
     return this.webaddress + spec;
   }
   public addbs(){//添加标识
     const bs = "ShopcenterAction.do?addShopcenterBs";
     return this.webaddress + bs;
   }
   public cardsubmit(){//卡类标识提交
     const card = "ShopcenterAction.do?addShopcenterPs";
     return this.webaddress + card;
   }
   public con(){//发送留言
     const con = "ContactAction.do?contactUs";
     return this.webaddress + con;
   }
   public showcontract(){//展示合同
     const contract = "ContractAction.do?showContract";
     return this.webaddress + contract;
   }
   public contractstatus(){//展示合同状态
    const contract = "ContractAction.do?getContractsBystatus";
    return this.webaddress + contract;
  }
   public checkpicnum(){//检测数据库合同数量
     const contract = "ContractAction.do?checkPicnum";
     return this.webaddress + contract;
   }
   public showOutshop(){//显示发货信息
     const contract = "OutshopAction.do?showOutshop ";
     return this.webaddress + contract;
   }
   public judgedownload(){//判断下载
     const contract = "ContractAction.do?isDownload";
     return this.webaddress + contract;
   }
   public applyinvoice(){//申请发票
     const invoice = "ContractAction.do?goApplyInvoice";
     return this.webaddress + invoice;
   }
   public isapply(){//是否申请发票
     const invoice = "ContractAction.do?isApply";
     return this.webaddress + invoice;
   }
   public checkinvoice(){//检查发票金额
     const money = "ContractAction.do?checkCmoney";
     return this.webaddress + money;
   }
   public delcontract(){//删除合同
     const del = "ContractAction.do?delContract";
     return this.webaddress + del;
   }
   public uploadcontract() {//上传合同图片
     const up = "ContractAction.do?uploadContract";
     return this.webaddress + up;
   }
   public getinvoicemes(){//获取发票信息
     const invoice = "InvoiceAction.do?findInvoice";
     return this.webaddress + invoice;
   }
   public addinv(){//添加发票信息
     const add = "InvoiceAction.do?addInvoice";
     return this.webaddress + add;
   }
   public newmes(){//新消息
     const newmes = "NewsAction.do?allContractNews";
     return this.webaddress + newmes;
   }
   public oldmes(){//已读消息
     const newmes = "NewsAction.do?allContractOld";
     return this.webaddress + newmes;
   }
   public ensuremes(){//消息确认
     const ensure = "NewsAction.do?confirmFlag";
     return this.webaddress + ensure;
   }
   public statistic(){//统计查询
     const sta = "QueryAction.do?queryContract";
     return this.webaddress + sta;
   }
   public getpay(){//统计查询
     const sta = "ShopcenterAction.do?payMoney&contractCode=";
     return this.webaddress + sta;
   }
   public labelplan(){//贴标方案
    const sta = "HomeAction.do?getLabelmachine";
    return this.webaddress + sta;
  }
  public pictures(){//贴标方案
    const sta = "pictures/label_machine/";
    return this.webaddress + sta;
  }
  public listinvoice(){//发票列表
    const sta = "ContractAction.do?goApplyInvoice";
    return this.webaddress + sta;
  }
  public invoices(){//开具发票
    const sta = "ContractAction.do?submitApplyInvoice";
    return this.webaddress + sta;
  }
 }



// WEBPACK FOOTER //
// ./src/service/httpaddress.ts